
import React from "react";

interface ProductLogoProps {
  logo?: string;
  fallbackText: string;
}

export function ProductLogo({ logo, fallbackText }: ProductLogoProps) {
  return (
    <div className="flex items-center justify-center">
      {logo ? (
        <img 
          src={logo} 
          alt={fallbackText} 
          className="max-w-full max-h-full object-contain"
        />
      ) : (
        <div className="text-3xl font-bold text-gray-400">
          {fallbackText.charAt(0)}
        </div>
      )}
    </div>
  );
}
